import * as React from 'react';
import AuthService from '../../abs/services/auth/authService';
import ABSResolvePhoneOrMail from '../ABSResolvePhoneOrMail';

export interface IABSPayedCommentProps {
  children?: React.ReactNode;
}

export default class ABSPayedComment extends React.Component<IABSPayedCommentProps> {
  static defaultProps = {
    children: `*此功能为专业版功能权限，详情请致电：`
  };
  render() {
    const userInfo = AuthService.getCurrentUser() || { isPayed: false };
    const { isPayed = false } = userInfo;
    if (isPayed) { return null; }
    return (
    <>{this.props.children}<ABSResolvePhoneOrMail type="tel"/></>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSPayedComment/index.tsx